import EventTracking from '../../event-tracking';
import IntegratorsHandler from 'src/apps/integrators_handler';

class ShowAppPage {
  static trackEvents() {
    const installAppButton = document.getElementById('installation-button');

    if (installAppButton) {
      const appId = installAppButton.dataset.appId;

      installAppButton.addEventListener('click', () => {
        EventTracking.trackAnonymous('Visitor clicked on Install App', appId, true);
      });
    }
  }
}

window.addEventListener('DOMContentLoaded', function () {
  ShowAppPage.trackEvents();
  IntegratorsHandler.renderTagsAndDrawer();
});
